import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import OtpInput from 'react-otp-input';
import { Box, Grid } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getOtp } from "redux/actions/UserOtp";
import Timer from "./Timer";
import BackDrop from 'components/backDrop/BackDrop';
import { companyDetailsEnum } from 'utils/companyDetails';

function Otp(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const pageType = searchParams.get('pageType');
  const userOtp = useSelector((state) => state);
  const isLoader = userOtp?.userOtp?.loading;

  const signupDetails = JSON.parse(localStorage.getItem("signUpDetails"));
  const loginDetails = JSON.parse(localStorage.getItem("loginDetails"));
  const userDetails = pageType ==='signupOtp' ? signupDetails : loginDetails;

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();
  const [errorOtp, setErrorOtp] = useState('');
  const [autoFocusOtp, setAutoFocusOtp] = useState(true);

  const resetOtp = () => {
    reset();
    setErrorOtp('');
  }

  const onSubmit = (data) => {
    const platform = 'AdminApp';
    // Handle form submission
    const otpDetails = {
      platform: platform,
      mobileOrEmail: userDetails?.mobile,
      otp: data,
      otpSecret: userDetails?.secretToken,
      countryCode: userDetails?.code
    };
    // dispatchEvent(call redux function: action -> saga -> reducer (update the store)
      dispatch(getOtp(otpDetails, navigate, {resetOtp: resetOtp, setAutoFocusOtp: setAutoFocusOtp}))
    
  };

  const onBackBtn = () => {
    localStorage.clear();

    if(pageType === "signupOtp") {
      navigate("/signup");
    }
    else {
      props?.onOtpPage(false);
    }
  };

  // ---Check Wheather mobile is present or not----
 useEffect(() => {
  if (!loginDetails?.mobile && pageType !== "signupOtp") {
    navigate("/login");
  } 
 }, [])

 useEffect(() => {
  if (isLoader) {
    setAutoFocusOtp(false);
  }
}, [isLoader]);
 

const handleOtpChange = (value) => {
  const validateNumber = /^\d+$/.test(value); // Check if value contains only digits
  if(!validateNumber){
    setErrorOtp('OTP must contain only numbers')
  }else if(value.length === 4 && validateNumber ){
    setErrorOtp("");
    onSubmit(value)
  }else{
    setErrorOtp(`OTP must be 4 characters long`);
  }
};

  return (
    <div>
      <Box sm={{ flexGrow: 1 }} className="mobileRes loginMain">
        <Grid container>
          <Grid item sm={6}>
          <Box
              alignItems={'center'}
              sx={{ display: { xs: 'none', sm: 'flex' } }}
              className="positionAbsolute otpLogo ml40"
            >
              <ArrowBackIcon
                onClick={() => {
                  onBackBtn();
                }}
              />
              <img src={companyDetailsEnum?.companyLogoDark} className="maxWidth" alt="otplogo" />
            </Box>

            {/* ---OTP input type--- */}
            <div className="loginInput mobileBg">
              <Grid
                container
                justifyContent="center"
                alignItems="center"
              >
                <Grid item sm={8} sx={{ textAlign: 'center' }} className="">
                  <div className="col-12 text-center">
                    <h1 className="fontBold font36 colorBlue m0">
                      Enter your <span className="colorYellow">OTP</span>
                    </h1>
                    <p className="colorGrey font16 fontNormal m0">
                      An authentication {companyDetailsEnum?.companyName} code has been sent to
                    </p>
                    <p className="colorGrey font16 fontMedium marginBottom35">{loginDetails?.mobile || signupDetails?.mobile}</p>
                  </div>
                </Grid>
                <Grid item sm={8}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    {/* ---OTP UI--- */}
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item sm={8} className="otpInput">
                        <Controller
                          name="otp"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: 'OTP is required',
                            minLength: {
                              value: 4,
                              message: 'OTP must be 4 characters long',
                            },
                          }}
                          render={({ field }) => (
                            <OtpInput
                              containerStyle="otp"
                              inputStyle={
                                errors.otp ? 'otpStyleError' : 'otpStyle'
                              }
                              value={field.value}
                              onChange={(value) => {
                                field.onChange(value);
                                handleOtpChange(value);
                              }}
                              numInputs={4}
                              inputType='tel'
                              renderInput={(props) => <input {...props} disabled={isLoader} />}
                              shouldAutoFocus={autoFocusOtp}
                            />
                          )}
                        />
                        {errorOtp && (
                          <p className="errorOtp">
                            <span>
                              <ErrorIcon />
                            </span>
                            {errorOtp}
                          </p>
                        )}
                      </Grid>
                      <Grid container item sm={8} justifyContent="center" className="otpInput">
                        {/* ---Timer Screen--- */}
                        <Grid item>
                          <div>
                            <Timer onResend={resetOtp} setAutoFocusOtp={setAutoFocusOtp} pageType={pageType}  />
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </div>
          </Grid>
          {/* ---Image Part--- */}
          <Grid item sm={6} sx={{ display: { xs: 'none', sm: 'flex' }}}  >
            <div className="otpName"></div>
          </Grid>
        </Grid>
      </Box>
      <BackDrop open={isLoader}/>
    </div>
  );
}

export default Otp;
